import { LocalStorageKey } from '@/enums/localStorageKey';
import { GenericError } from '@/models/generic-error';
import { BettingSessionTimePlayedInputDto } from '@/services/dto/betiing-session/betting-session-time-played-input.dto';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { fetchBettingSessionTimePlayed } from './service';

export function useBettingSessionTimePlayed() {
  function onSuccess(data: void, variables: BettingSessionTimePlayedInputDto) {
    sessionStorage.removeItem(LocalStorageKey.BettingSessionId);
  }

  const {
    mutate,
    mutateAsync,
    isPending: isLoading,
    error,
    data,
    isError,
    reset,
  } = useMutation<
    void,
    AxiosError<GenericError>,
    BettingSessionTimePlayedInputDto
  >({
    mutationFn: fetchBettingSessionTimePlayed,
    onSuccess,
  });

  return {
    bettingSessionTimePlayed: mutate,
    bettingSessionTimePlayedAsync: mutateAsync,
    isLoading,
    reset,
    error,
    isError,
    data,
  };
}
